import styled from 'styled-components'
import Footer from '../../components/footer/Footer'
import Header from '../../components/header/Header'
import {
    BiomarkersContainer,
    Container,
    Title,
} from '../recommendations/Recommendations'
import MeasuredBiomarkers from '../../components/measuredBiomarkers/MeasuredBiomarkers'
import AboutBiomarker from '../../components/modals/AboutBiomarker'
import {Link, useNavigate} from 'react-router-dom'
import {useContext, useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next'
import getIndicators from '../../components/http/getIndicators'
import getSubjectId, {getHashObj, getUrl} from '../../components/getSubjectId'
import {getDefatultIndicatorValues} from '../../utils/biomarkers'
import _ from 'underscore'
import GlobalContext from '../../components/GlobalContext'
import ContainerContent from './../../components/ContainerContent'

const Background = styled.div``
const Block = styled.div`
  /* margin-top: 60px; */
  width: 100%;
`

const DescriptionText = styled.p`
  margin: 0px;
  margin-top: 25px;
  margin-bottom: -5px;
  color: var(--text-secondary, #808080);

  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0.48px;
`

const Box = styled.div`
  width: 100%;

    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-column-gap: 12px;
    grid-row-gap: 12px;

  a {
    text-decoration: none;
  }
`

function calcIndicator(indicator: any, hashObj: any) {
    let value = hashObj[indicator._id]

    function isNum(v: any) {
        return v || v == '0' ? true : false
    }

    indicator = indicator || {}

    let values = indicator.signals.map((it: any, index: number) => {
      let next = (indicator.signals || [])[index + 1] || {}
      return {from: +it.valueFrom, to: +it.valueTo || +(next || {}).valueFrom}
    })
    let avgObj = {sum: 0, count: 0}
    _.each(values, (item: any, ind: number) => {
        if (isNum(item.from) && isNum(item.to)) {
            avgObj.sum += item.to - item.from
            avgObj.count++
        }
    })
    let avgValue = avgObj.sum / (avgObj.count || 1)
    _.each(values, (item, ind) => {
        if (!item.to) {
            item.to = item.from + avgValue
        }
    })
    let delta = values.at(-1).to - values.at(0).from
    let selectedInd = 0
    value = value || 0
    let splitColors = (indicator.scaleType || 'RAGAR').split('')
    let _colors = splitColors.map((it: string) => {
        return {R: '#E96863', G: '#C2EAED', A: '#FFECB3'}[it] || 'red'
    })

    _.each(values, (item, ind) => {
        item.perc = 100 * ((item.to - item.from) / delta)
        item.color = _colors[ind]
        // @ts-ignore
        if (value > item.from) {
            selectedInd = ind
        }
    })

    let perc = Math.max(
        Math.min(99, (100 * ((value || 0) - values[0].from)) / delta),
        1
    )

    indicator._values = values
    indicator.perc = perc
    indicator.selectedInd = selectedInd
    indicator.color = _colors[selectedInd]
    indicator.scaleValue = splitColors[selectedInd]

    return indicator
}

const Main = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const {dbs, info} = useContext(GlobalContext)
    const [indicators, setIndicators] = useState<any>([])
    // const navigate = useNavigate()
    // const values = getDefatultIndicatorValues()
    // const hashObj = getHashObj() || {};
    useEffect(() => {
        let values = getDefatultIndicatorValues()
        if (!values?.theme) {
            return navigate('/home')
        }
        console.log("qqqqq vvvvvv", values);
    }, [])
    //
    // let _indicators = indicators.map((it: any) => {
    //   return calcIndicator(it, hashObj)
    // })
    let groups = [
        {key: 'R', name: t('attention')},
        {key: 'A', name: t('monitorModerativeRisk')},
        {key: 'GL', name: t('optimal')},
        {key: 'G', name: t('optimal')},
        {isGrey: true, key: 'GREY', name: t('other')},
    ]
    let grouppedIndicators = _.groupBy(info.indicators, 'scaleValue')
    console.log("qqqqq grouppedIndicators", grouppedIndicators);
    grouppedIndicators.R = [...grouppedIndicators.R || [], ...grouppedIndicators.R2 || []]
    grouppedIndicators.A = [...grouppedIndicators.A || [], ...grouppedIndicators.A2 || []]

    let _indicators = indicators
    console.log('qqqqq dbs', dbs, info, grouppedIndicators)

    console.log('qqqqq hashObj', _indicators)
    return (
      <ContainerContent>
        <div>
          <div data-grey className={'pf'}>
            <div data-animch >
              <Title>Measured Biomarkers</Title>
              <div className={'paddB'}  data-animch={3}>
                {(groups || []).map((it, ind) => {
                  let arr = grouppedIndicators[it.key] || [];
                  return (!arr || !arr.length ? <></> :
                    <div key={ind}>
                      <DescriptionText>{it.name}</DescriptionText>
                      <Box key={ind} data-box>
                        {(arr).map((it, ind) => {
                          return (
                            <MeasuredBiomarkers
                              indicator={it}
                              key={ind}
                              isGrey={it.isGrey}
                              value={it._value}
                            />
                          )
                        })}
                      </Box>
                    </div>
                  )
                })}
                <div style={{marginTop: '25px', marginBottom: '0px', display: 'block'}}>
                  <Link to={getUrl('form')} className={'linkHover'}>Change Biomarkers</Link>
                </div>
              </div>
            </div>
            {/*<AboutBiomarker></AboutBiomarker>*/}
          </div>
        </div>
      </ContainerContent>
    )
}

export default Main
